import React from "react";
import "./QuoteBlock.css";
import parse from "html-react-parser";
import { APP_COLORS } from "../../constants/styles";
import CustomLink from "../../utils/customLink";
import { useGetLink } from "../../utils/useOpenLink";

function QuoteBlock({ body, colors: colorObj, block_buttons }) {
    const { getLink } = useGetLink();

    return (
        <div className="quote-section" style={APP_COLORS(colorObj)}>
            <div className="quote-container">
                <div className="decorative-line top"></div>

                <div className="quote-text">{parse(body)}</div>

                <div className="attribution text-left">
                    {block_buttons?.length > 0 && (
                        <div className="flex flex-col gap-2 items-start">
                            {block_buttons.map((v, index) => {
                                const link = getLink(v.action);
                                const isLink = !!link;

                                const commonClasses = "title block w-full text-left";
                                const linkClasses = isLink
                                    ? "text-primary_color underline cursor-pointer"
                                    : "text-accent_color1";

                                return isLink ? (
                                    <CustomLink to={link} key={index} className="w-full">
                                        <span
                                            className={`${commonClasses} ${linkClasses}`}
                                            style={{ "--accent_color3": colorObj?.accent_color3 }}
                                        >
                                            {parse(v.label)}
                                        </span>
                                    </CustomLink>
                                ) : (
                                    <span key={index} className={`${commonClasses} ${linkClasses}`}>
                                        {parse(v.label)}
                                    </span>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="decorative-line bottom"></div>
            </div>
        </div>
    );
}

export default QuoteBlock;
